module.exports = __webpack_public_path__ + "static/home__talk-to-us.8ec8c54d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home__talk-to-us.jpg
// module id = 509
// module chunks = 35783957827783